import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 200 200",
  style: {"width":"100%","height":"100%"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M80.4 92.9h.5c3.2 0 6.2-3 6.1-6.5V16.5c0-3.5-2.8-6.5-6.1-6.5H16.1c-3.3 0-6.1 3-6.1 6.5v69.8c0 3.5 2.8 6.5 6.1 6.5h64.3zm-5.6-13.1V23.1H22.2v56.7h52.6zM80.4 190h.5c3.2 0 6.2-3 6.1-6.5v-69.8c0-3.5-2.8-6.5-6.1-6.5H16.1c-3.3 0-6.1 3-6.1 6.5v69.8c0 3.5 2.8 6.5 6.1 6.5h64.3zm-5.6-13.1v-56.7H22.2v56.7h52.6zM174.3 35h-68.9c-3.4 0-5.9-3-6.1-6.5-.1-3.5 2.9-6.5 6.1-6.5h78.5c3.4 0 5.9 3 6.1 6.5.1 3.5-2.9 6.5-6.1 6.5h-9.6zm0 45.9h-68.9c-3.4 0-5.9-3-6.1-6.5-.1-3.5 2.9-6.5 6.1-6.5h78.5c3.4 0 5.9 3 6.1 6.5.1 3.5-2.9 6.5-6.1 6.5h-9.6zm0 51.7h-68.9c-3.4 0-5.9-3-6.1-6.5-.1-3.5 2.9-6.5 6.1-6.5h78.5c3.4 0 5.9 3 6.1 6.5.1 3.5-2.9 6.5-6.1 6.5h-9.6zm0 46.2h-68.9c-3.4 0-5.9-3-6.1-6.5-.1-3.5 2.9-6.5 6.1-6.5h78.5c3.4 0 5.9 3 6.1 6.5.1 3.5-2.9 6.5-6.1 6.5h-9.6z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("span", {
    class: "tri-icon",
    style: _normalizeStyle(`font-size: ${_ctx.size}; color: ${_ctx.color}; width: 1em; height: 1em; display:block; line-height: 0;`)
  }, [
    (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
  ], 4))
}